import * as types from './types';
import firebaseService from 'Services/firebaseService';

export function getUserItems() {
  return (dispatch) => {
    firebaseService
      .getUserItems()
      .then((response) => {
        dispatch({
          type: types.SET_USER_ITEMS,
          payload: response,
        });
      })
      .catch((error) => {
        // todo should have some dispatch error here
        console.warn('Error getting user items : ', error);
      });
  };
}

export function deleteItem(itemId) {
  return (dispatch) => {
    firebaseService
      .deleteItem(itemId)
      .then((responseJSON) => {
        dispatch({
          type: types.DELETE_ITEM,
          payload: itemId,
        });
      })
      .catch((error) => {
        // todo should have some dispatch error here
        console.warn('Error deleting item : ', error);
        alert('Deleting item error' + error);
      });
  };
}
